import { render, staticRenderFns } from "./ProtocolFindingsPopup.vue?vue&type=template&id=6defb763"
import script from "./ProtocolFindingsPopup.vue?vue&type=script&lang=js"
export * from "./ProtocolFindingsPopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports